import UAParser from "ua-parser-js"
import moment from 'moment-timezone';
import hash from 'object-hash';

angular.module('ResearchKitApplicationModule').factory("participantDeviceInfoService", ["$http", "$window", "ceUrl", function ($http, $window, ceUrl) {

    function getBrowser() {
        let parser = new UAParser();
        return parser.getResult().browser;
    }

    function getDeviceInfo() {
        let resolution = '';
        if ($window.screen && $window.screen.width && $window.screen.height) {
            resolution = $window.screen.width + " x " + $window.screen.height;
        }

        let parser = new UAParser();
        let result = parser.getResult();

        let properties = {
            Browser: result.browser.name,
            BrowserVersion: result.browser.version,
            OperatingSystem: result.os.name,
            Resolution: resolution,
            Device: result.device.model,
            DeviceType: result.device.type
        };
        let deviceIdentifier = hash({ ...properties, BrowserVersion: "" });

        let deviceInfo = {
            identifier: deviceIdentifier,
            platform: 'Web',
            properties: properties
        };

        return deviceInfo;
    }

    function captureDeviceInfo() {
        let url = "api/researchkit/studyparticipant/captureparticipantdevice/";

        let capturePayload = {
            offset: moment().format("Z"),
            device: getDeviceInfo(),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };

        $http.post(ceUrl.make(url), capturePayload);
    }

    return {
        captureDeviceInfo: captureDeviceInfo,
        getDeviceInfo: getDeviceInfo,
        getBrowser: getBrowser
    };
}]);